import _Object$keys from "@babel/runtime-corejs3/core-js-stable/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor";
import _forEachInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/for-each";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js-stable/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js-stable/object/define-property";
import _objectWithoutProperties from "@babel/runtime-corejs3/helpers/objectWithoutProperties";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
var _excluded = ["headers", "usingTable", "item", "rowIndex", "tableRowClassName", "style", "tableCellStyle", "onRowMouseOver", "loading", "stickyFirstColumn", "isLastRow", "isFirstRow", "borderRadius", "showStickyColumnShadow"];
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/map";
import _concatInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/concat";
import _trimInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/trim";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var _context4, _context5; var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? _forEachInstanceProperty(_context4 = ownKeys(Object(t), !0)).call(_context4, function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : _forEachInstanceProperty(_context5 = ownKeys(Object(t))).call(_context5, function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
import { makeStyles, TableCell, TableRow, Box, RaiseColors, useTheme } from "components/mui";
import * as React from "react";
import { stickyColumnShadowStyles } from "../stickyColumnStyles";
import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
var useStyles = function useStyles() {
  var theme = useTheme();
  return makeStyles(function () {
    return {
      cell: {
        position: "relative"
      },
      focusedCell: {
        boxShadow: theme.shadows[1]
      },
      stickyCell: _objectSpread({
        position: "relative"
      }, stickyColumnShadowStyles),
      stickyCellPositioned: {
        position: "sticky",
        left: 0,
        zIndex: 2
      },
      stickyCellPositionedWithShadow: _objectSpread({
        position: "sticky",
        left: 0,
        zIndex: 2
      }, stickyColumnShadowStyles),
      stickyCellFirstRow: {
        borderTopLeftRadius: "16px"
      },
      stickyCellLastRow: {
        borderBottomLeftRadius: "16px"
      }
    };
  });
};
function Row(_ref) {
  var headers = _ref.headers,
    usingTable = _ref.usingTable,
    item = _ref.item,
    rowIndex = _ref.rowIndex,
    tableRowClassName = _ref.tableRowClassName,
    _ref$style = _ref.style,
    style = _ref$style === void 0 ? {} : _ref$style,
    _ref$tableCellStyle = _ref.tableCellStyle,
    tableCellStyle = _ref$tableCellStyle === void 0 ? {} : _ref$tableCellStyle,
    _ref$onRowMouseOver = _ref.onRowMouseOver,
    onRowMouseOver = _ref$onRowMouseOver === void 0 ? function () {} : _ref$onRowMouseOver,
    loading = _ref.loading,
    _ref$stickyFirstColum = _ref.stickyFirstColumn,
    stickyFirstColumn = _ref$stickyFirstColum === void 0 ? false : _ref$stickyFirstColum,
    _ref$isLastRow = _ref.isLastRow,
    isLastRow = _ref$isLastRow === void 0 ? false : _ref$isLastRow,
    _ref$isFirstRow = _ref.isFirstRow,
    isFirstRow = _ref$isFirstRow === void 0 ? false : _ref$isFirstRow,
    borderRadius = _ref.borderRadius,
    _ref$showStickyColumn = _ref.showStickyColumnShadow,
    showStickyColumnShadow = _ref$showStickyColumn === void 0 ? false : _ref$showStickyColumn,
    props = _objectWithoutProperties(_ref, _excluded);
  var classes = useStyles()();
  return /*#__PURE__*/_jsx(TableRow, _objectSpread(_objectSpread({
    hover: true,
    className: tableRowClassName,
    style: style,
    onMouseOver: function onMouseOver(e) {
      onRowMouseOver({
        item: item,
        event: e
      });
    }
  }, props), {}, {
    children: _mapInstanceProperty(headers).call(headers, function (header, cellIndex) {
      var customClassName = header.getCellClassName ? header.getCellClassName({
        item: item,
        rowIndex: rowIndex
      }) : null;
      var isStickyFirstColumn = cellIndex === 0 && stickyFirstColumn;
      var backgroundColor = (tableCellStyle === null || tableCellStyle === void 0 ? void 0 : tableCellStyle.backgroundColor) || RaiseColors.white;

      // Build className based on conditions
      var cellClassName = customClassName || classes.cell;
      if (isStickyFirstColumn) {
        var _context, _context2, _context3;
        var baseClass = showStickyColumnShadow ? classes.stickyCellPositionedWithShadow : classes.stickyCellPositioned;
        var borderClass = isFirstRow && isLastRow ? _concatInstanceProperty(_context = "".concat(classes.stickyCellFirstRow, " ")).call(_context, classes.stickyCellLastRow) : isFirstRow ? classes.stickyCellFirstRow : isLastRow ? classes.stickyCellLastRow : "";
        cellClassName = _trimInstanceProperty(_context2 = _concatInstanceProperty(_context3 = "".concat(baseClass, " ")).call(_context3, borderClass)).call(_context2);
      }
      return /*#__PURE__*/_jsx(TableCell, _objectSpread(_objectSpread({
        className: cellClassName,
        style: _objectSpread(_objectSpread({
          width: header.width || "initial",
          maxWidth: (header === null || header === void 0 ? void 0 : header.maxWidth) || "initial",
          padding: "16px 12px"
        }, tableCellStyle), isStickyFirstColumn ? {
          backgroundColor: backgroundColor
        } : {})
      }, header.tableCellProps || {}), {}, {
        children: loading ? /*#__PURE__*/_jsx(LoadingCell, {}) : /*#__PURE__*/_jsx(_Fragment, {
          children: header.renderCell({
            item: item,
            rowIndex: rowIndex,
            usingTable: usingTable
          })
        })
      }), cellIndex);
    })
  }));
}
var LoadingCell = function LoadingCell() {
  return /*#__PURE__*/_jsx(Box, {
    bgcolor: RaiseColors.gray100,
    height: 16,
    width: "100%"
  });
};
export default Row;